























import Vue from 'vue';
export default Vue.extend({
  data() {
    return {
      data: [
        {
          id: 'entry-1',
          product: 'product 1',
          price: '1.00',
        },
        {
          id: 'entry-2',
          product: 'product 2',
          price: '1.00',
        },
        {
          id: 'entry-3',
          product: 'product 3',
          price: '1.00',
        },
      ],
    };
  },
});
